export default "__VITE_ASSET__kVO0Z$wG__"